<template>
  <div>
    <v-row class="tabs-demo__size">
      <v-col :span="22">
        <v-tabs
          v-model="activeNamebutton"
          size="S"
          name="tabs-s-card"
          type="button"
        >
          <v-tab-pane label="运行状态" value="1">
            <RunStatus :devKey="devKey" ></RunStatus>
          </v-tab-pane>
          <v-tab-pane label="事件管理" value="2">
            <EventManage :devKey="devKey" ></EventManage>
          </v-tab-pane>
          <v-tab-pane label="服务调用" value="3">
            <ServeCall :devKey="devKey"></ServeCall>
          </v-tab-pane>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RunStatus from "./physical-model/run-status.vue";
import EventManage from "./physical-model/event-manage.vue";
import ServeCall from "./physical-model/serve-call.vue";

export default {
  components: { RunStatus, EventManage, ServeCall },
  props: {
    devName: {},
    devId: {},
    devKey: {},
  },
  data() {
    return {
      activeNamebutton: "",
    };
  },
  created() {},

  methods: {},
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
